<template>
  <div class="category">
    <div v-if="showTitle" class="title">问题集</div>
    <el-row>
      <el-col class="categoryItem" :span="6" v-if="showLeft">
        <div
          :class="['cateItm', item.isActive ? 'active' : '']"
          v-for="(item, index) in cateList"
          :key="index"
          @click="handleClick(item.name)"
        >{{item.name}}</div>
        <span class="sizedBox"></span>
      </el-col>
      <el-col class="detailList" :span="showLeft ? 18 : 24" v-if="showRight">
        <div v-if="isShow" class="prompt">暂无数据</div>
        <div
          class="detailItem"
          v-for="(item, index) in detailList"
          :key="index"
          @click="handleClick2(item.gid)"
        >
          <div class="name">{{item.name}}</div>
          <div v-if="!showTitle" class="download">下载</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
    cateList: {
      type: Array,
      default: () => [],
    },
    detailList: {
      type: Array,
      default: () => [],
    },
    showLeft: {
      type: Boolean,
      default: true,
    },
    showRight: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleClick(val) {
      this.$emit("click", val);
    },
    handleClick2(val) {
      this.$emit("select", val);
    },
  },
  computed: {
    isShow() {
      if (this.detailList.length > 0) return false;
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.category {
  margin-top: 20px;
  width: 100%;
  height: 700px;
  background: #fff;
  border-radius: 2px;
  padding: 24px 0;
  position: relative;
  .title {
    font-size: 16px;
    color: #2c3a50;
    margin: 0 26px;
    padding-bottom: 22px;
    border-bottom: 1px solid #e2e5ec;
  }
  .sizedBox {
    width: 4px;
    height: 640px;
    background: RGBA(246, 247, 249, 1);
    position: absolute;
    right: 3%;
    top: 20px;
  }
  .categoryItem {
    padding: 20px;
    position: relative;
    box-sizing: border-box;
    div {
      width: 95%;
      height: 40px;
      border: 1px solid rgba(201, 209, 212, 0.7);
      border-radius: 5px;
      box-sizing: border-box;
      line-height: 40px;
      margin-bottom: 14px;
      font-size: 16px;
      color: #576071;
      background: url("../../assets/img/document/document.png") no-repeat;
      background-size: 26px 26px;
      background-position: 8px 7px;
      padding-left: 42px;
      cursor: pointer;
      &.active {
        color: var(--themeColor);
        border-color: var(--themeColor);
        background: url("../../assets/img/document/document_active.png")
          no-repeat;
        background-size: 26px 26px;
        background-position: 8px 7px;
      }
    }
  }
  .detailList {
    box-sizing: border-box;
    padding: 20px;
    .prompt {
      margin-top: 100px;
      text-align: center;
      font-size: 16px;
      color: #99a9ba;
    }
    .detailItem {
      color: #2c3a50;
      width: 95%;
      height: 40px;
      border: 1px solid rgba(201, 209, 212, 0.7);
      border-radius: 5px;
      box-sizing: border-box;
      line-height: 40px;
      margin-bottom: 14px;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      padding: 0 42px;
      position: relative;
      cursor: pointer;
      &::before {
        content: "";
        border-radius: 6px;
        background: RGBA(168, 175, 188, 1);
        position: absolute;
        width: 6px;
        height: 6px;
        top: 17px;
        left: 28px;
      }
      .download {
        font-size: 15px;
        text-decoration: underline;
        color: var(--themeColor);
      }
    }
  }
}
</style>